<!-- 现金充值弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">充值</template>
		<div style="padding-top: 20px;">

			<div class="formContainer">

				<label><span class="required">*</span>充值设备</label>

				<div style="float: right;width: 200px;margin-right: 195px"  >
					<el-select v-model="device"  collapse-tags placeholder="请选择" size='small'>
						<!--						<el-option label='全选' value='全选' @click.native='selectAll'></el-option>-->
						<el-option v-for="(item,index) in userDeviceInfo" :key="index" :label="item.deviceName"  :value="index">
						</el-option>
					</el-select>
				</div>

			</div>

			<div class="formContainer">
				<label><span class="required">*</span>登录密码</label>
				<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" maxlength="100" placeholder="请输入登录密码" />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>充值金额</label>
				<input type="number" v-model="chargeNum" min="0" placeholder="请输入充值金额" @keydown="keydownFloat($event)" />
				<span style="margin-left: 10px;">元</span>
			</div>

			<div class="formContainer" v-show="deviceObject.meterRunType==1 && deviceObject.accountType==1">
				<label><span class="required">*</span>金额转换电度</label>
				<input type="number" v-model.trim="deviceObject.conversionRate" autocomplete="new-password" maxlength="100" placeholder="金额转换电度" /><span class="required">元/度</span>
			</div>

			<p class="balance" v-if="deviceObject.meterRunType==1 && deviceObject.accountType==1">充值电度:<span>{{chargeNum/deviceObject.conversionRate}}</span>度</p>
			<p class="balance" v-else>充值后余额为:<span>{{balance}}</span>元</p>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {

		},
		data() {
			return {
				callback: undefined,
				verifyPassword: '',
				conversionRate: '',
				chargeNum: 0,
				nowbalance: 0,
				userDeviceInfo: [],
				device: undefined,
				deviceObject:{}
			}
		},
		computed: {
			balance() {
				if(isNaN(parseFloat(this.chargeNum))){
					return (this.nowbalance / 100).toFixed(2)
				}else{
					return (this.nowbalance / 100 + parseFloat(this.chargeNum)).toFixed(2)
				}
			}
		},
		watch: {
			device(nv,ov) {
				if(nv != undefined) {
					this.deviceObject = this.userDeviceInfo[nv];
				}
			}

		},
		mounted() {},
		methods: {
			confirm() {
				if(this.verifyPassword == '' || this.verifyPassword == undefined){
					this.$dialogMethod.showMessage('必填项不可为空')
					return
				}else if(isNaN(parseFloat(this.chargeNum)) || (this.chargeNum.indexOf('.') > 0 && this.chargeNum.split('.')[1].length > 2)){
					this.$dialogMethod.showMessage('请填写正确的充值金额')
					return
				}else if(parseFloat(this.chargeNum) <= 0){
					this.$dialogMethod.showMessage('充值金额不能为0')
					return
				}
				//debugger

				if (this.deviceObject.deviceNo== ''){
					this.$dialogMethod.showMessage('请选择充值设备')
					return
				}

				if (this.deviceObject.meterRunType==1 && this.deviceObject.accountType==1){

					if (this.deviceObject.conversionRate == ''){
						this.$dialogMethod.showMessage('金额转换电度不能为空')
						return
					}
				}
				this.chargeNum = this.chargeNum;
				if(this.callback != undefined){
					this.callback(hex_md5(this.verifyPassword), parseFloat(this.chargeNum),this.deviceObject.deviceNo,this.deviceObject.conversionRate)
				}
				this.close()
			},

			changeFn() {
				//debugger;
				//console.info("设备:"+this.device);
				//console.info("设备2:"+this.device.deviceNo);
			},

			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.userDeviceInfo = ''
				this.chargeNum = 0
				this.$refs.body.hide()
				this.setDeviceNull()
			},
			open(userDeviceInfo, balance, callBack) {
				//debugger
				this.nowbalance = balance
				this.callback = callBack
				this.userDeviceInfo = userDeviceInfo
				this.$refs.body.open()
			},

			setDeviceNull(){
				this.device = undefined;
				this.deviceObject={}
			},

			keydownFloat(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 229){
					ev.preventDefault()
				}
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 12px;
	}

	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}

	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}

	.required{
		color: red;
	}

	.balance{
		text-align: right;
	}
	.balance>span{
		color: #FF9900;
		font-size: .18rem;
		font-weight: bold;
	}
</style>